import React, { Component } from "react";

export default class LoadingLogo extends Component {
  static defaultProps = {};

  constructor(props: any) {
    super(props);
  }

  render() {
    return <div className="klayo-loading-logo"></div>;
  }
}
